import { createApi } from '@reduxjs/toolkit/query/react';
import { btBaseQuery } from 'src/Common/common';

// Define a service using a base URL and expected endpoints
export const usersApi = createApi({
  reducerPath: 'usersApi',
  baseQuery: btBaseQuery,
  tagTypes: ['User'],

  endpoints: (builder) => ({
    getUsers: builder.query<auser[], string>({
      query: (cid) => `users/${cid}`,
      providesTags: ['User']
    }),
    getUser: builder.query<auser, string>({
      query: (id) => `users/byid/${id}`
    }),
    signIn: builder.mutation({
      query: (user) => ({
        url: `/users/signin/`,
        method: 'POST',
        body: user
      })
    }),
    updateUserPasswd: builder.mutation({
      query: (user) => ({
        url: `users/passwd`,
        method: 'PUT',
        body: user
      }),
      invalidatesTags: ['User']
    }),
    insertUser: builder.mutation({
      query: (user) => ({
        url: `/users/`,
        method: 'POST',
        body: user
      }),
      invalidatesTags: ['User']
    }),
    updateUser: builder.mutation({
      query: (user) => ({
        url: `/users/`,
        method: 'PUT',
        body: user
      }),
      invalidatesTags: ['User']
    }),
    deleteUser: builder.mutation({
      query: (user) => ({
        url: `/users/${user.us_id}`,
        method: 'DELETE',
        body: user
      }),
      invalidatesTags: ['User']
    })
  })
});

// Export hooks for usage in functional components, which are
// auto-generated based on the defined endpoints
export const {
  useGetUsersQuery,
  useGetUserQuery,
  useSignInMutation,
  useUpdateUserPasswdMutation,
  useInsertUserMutation,
  useUpdateUserMutation,
  useDeleteUserMutation
} = usersApi;
